<script>
  import ClosuresCard from './ClosuresCard.svelte';
  import { getSortByString } from '../../utils/sorters';

  export let closuresData;
  export let metricsData;

  closuresData = closuresData.sort(getSortByString('county', true));

  let selectedCountyName = 'Los Angeles';
  $: selectedCountyClosures = closuresData.find(
    (c) => c.county == selectedCountyName
  );
  $: selectedCountyMetrics = metricsData.find(
    (c) => c.county == selectedCountyName
  );

  const onChange = (e) => {};
</script>

<div class="filtered-list" id="closures_nav">
  <select
    id="closures_select"
    name="counties"
    bind:value={selectedCountyName}
    on:blur={onChange}
  >
    <option value="Los Angeles">Select a county </option>
    {#each closuresData as county}
      <option value={county.county}>{county.county}</option>
    {/each}
  </select>
  <div class="minimap-key">
    <span style="background-color: #802f67;" />Tier 1
    <span style="background-color: #c43d53;" />Tier 2
    <span style="background-color: #d97641;" />Tier 3
    <span style="background-color: #e6b735;" />Tier 4
  </div>
</div>

<ClosuresCard bind:selectedCountyClosures bind:selectedCountyMetrics />


